module.exports = __webpack_public_path__ + "static/img/60.77726de8.png";